/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { EmailNotificationTypes } from './EmailNotificationTypes';
import { NotificationReasons } from './NotificationReasons';
const NotificationSettingOptionParser = 
/* #__PURE__ */ parsers.object([
    ['reason', NotificationReasons],
    ['explanation', codecString],
    ['value', EmailNotificationTypes],
]);
export class NotificationSettingOption extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NotificationSettingOptionParser.decode(input).map(res => new NotificationSettingOption(res));
    }
    static unsafeDecode(input) {
        return NotificationSettingOption.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NotificationSettingOptionParser.encode(data);
    }
    static schema() {
        return NotificationSettingOptionParser.schema();
    }
}
